import { useContext } from 'react';
import TradeContext, {
  useGetTradeInStatus
} from '~/context/common/TradeContext';
import useGetIsInTaxSavingRestrictedState from './useGetIsInTaxSavingRestrictedState';

export default function useShowTradeIncentives() {
  const { selectedTrade } = useContext(TradeContext);
  const { maxTradeTaxSavings, tradeIncentive } = selectedTrade ?? {};
  const { isExpired, isPending } = useGetTradeInStatus();
  const isSavingsOnly = Boolean(maxTradeTaxSavings && !tradeIncentive);
  const isInRestrictedState = useGetIsInTaxSavingRestrictedState();

  const hasExperimentValues = Boolean(maxTradeTaxSavings || tradeIncentive);
  const canShowSavingsOnly = !(isInRestrictedState && isSavingsOnly);

  const isEligibleLifecycleState = !isExpired && !isPending;

  return hasExperimentValues && isEligibleLifecycleState && canShowSavingsOnly;
}
